export const noSpaces = (value) => value?.trim()?.replaces(/ /g, '');

export const cellPhone = (value) => {
  const t = value;
  return t;
};
